import { Injectable } from '@angular/core';
import {TzPipe} from 'angular-moment-timezone';
import {AppConstants} from './app.constants';
import {Headers, RequestOptions} from '@angular/http';
import {CustomHttp} from './customhttp';
import {HttpClient, HttpRequest} from '@angular/common/http';

@Injectable()
export class FileUploadServiceService {

  constructor(public http: HttpClient) { }
  fileUpload (file) {
    const creationDate = new Date(new TzPipe().transform(new Date(), 'Europe/Istanbul', false));
    const apiURL = AppConstants.API_ENDPOINT +  '/ilan/upload-image-file/creationDate/' + creationDate;;
    const headers = new Headers({ 'Content-Type': 'application/json' });
    const options = new RequestOptions({ headers: headers });
    const formData: FormData = new FormData();
    formData.append('image' , file);

    return this.http.post(apiURL, formData);
  }
}



// WEBPACK FOOTER //
// C:/Users/user/Desktop/otojet-git/OtojetUI-Spring-Admin-Project/src/app/file-upload-service.service.ts